import {
  ProfileExportSelection,
  type CreateProfilesListReportPayload,
  type ExportProfilesFormValues,
} from "../../../generate-reports/report.types";
import { ReportTypes } from "../../../generate-reports/report.constant";
import { sources } from "../../../../shared/constants/common.constant";

export const DEFAULT_EXPORT_PROFILES_FORM_VALUES: ExportProfilesFormValues = {
  profileSearches: false,
  keyParties: false,
  keyPartySearches: false,
  fileName: "",
};

export const OPTIONAL_EXPORT_SELECTION_FIELDS = [
  "profileSearches",
  "keyParties",
  "keyPartySearches",
] as const satisfies ReadonlyArray<keyof ExportProfilesFormValues>;

export const buildProfileExportSelections = (
  values: ExportProfilesFormValues
): ProfileExportSelection[] => {
  const selections: ProfileExportSelection[] = [];

  if (values.profileSearches) {
    selections.push(ProfileExportSelection.ProfileSearches);
  }

  if (values.keyParties) {
    selections.push(ProfileExportSelection.KeyParties);
  }

  if (values.keyPartySearches) {
    selections.push(ProfileExportSelection.KeyPartySearches);
  }

  return selections;
};

export const buildProfilesListReportPayload = (
  values: ExportProfilesFormValues,
  teamId: string
): CreateProfilesListReportPayload => {
  const profilesExportSelections = buildProfileExportSelections(values);

  return {
    type: ReportTypes.profilesExport,
    source: sources.app,
    fileName: values.fileName.trim(),
    criteria: {
      teamIds: [teamId],
      ...(profilesExportSelections.length > 0
        ? { profilesExportSelections }
        : {}),
    },
  };
};

export const areAllOptionalSelectionsChecked = (
  values: ExportProfilesFormValues
): boolean =>
  values.profileSearches && values.keyParties && values.keyPartySearches;

export const areSomeOptionalSelectionsChecked = (
  values: ExportProfilesFormValues
): boolean =>
  values.profileSearches ||
  values.keyParties ||
  values.keyPartySearches;

export type ExportIncludesSummaryKey =
  | "profiles"
  | "profileSearches"
  | "keyParties"
  | "keyPartySearches";

export const buildExportIncludesSummaryKeys = (
  values: ExportProfilesFormValues
): ExportIncludesSummaryKey[] => {
  const keys: ExportIncludesSummaryKey[] = ["profiles"];

  if (values.profileSearches) {
    keys.push("profileSearches");
  }

  if (values.keyParties) {
    keys.push("keyParties");
  }

  if (values.keyPartySearches) {
    keys.push("keyPartySearches");
  }

  return keys;
};
